import {APIDefinitionSpec, APIDataSpec, defineEndpoint} from '../API';
import {OrganizationState} from '../../store/partials/Organization';
import {App} from '../../types/commons';

export const enum MiscAPI {
    PUBLIC_APPS = 'PUBLIC_APPS',
    CREATE_MANIFEST_FROM_APP_URL = 'CREATE_MANIFEST_FROM_APP_URL',
    ORG_SETTINGS = 'ORG_SETTINGS',
}

export const MiscData: APIDataSpec<typeof MiscAPI> = {
    PUBLIC_APPS: defineEndpoint(MiscAPI.PUBLIC_APPS, 'https://app-directory.openfin.co/api/v1/apps'),
    CREATE_MANIFEST_FROM_APP_URL: defineEndpoint(MiscAPI.CREATE_MANIFEST_FROM_APP_URL, 'api/app.json?appurl=${appUrl}&runtime=${runtimeVersion}'),
    ORG_SETTINGS: defineEndpoint(MiscAPI.ORG_SETTINGS, 'api/config')
};
export interface MiscTypes extends APIDefinitionSpec<MiscAPI> {
    [MiscAPI.PUBLIC_APPS]: {
        GET: [App[], void];
    };
    [MiscAPI.CREATE_MANIFEST_FROM_APP_URL]: {
        GET: [any, {appUrl: string; runtimeVersion: string}];
    };
    [MiscAPI.ORG_SETTINGS]: {
        GET: [OrganizationState | null, void];
    };
}
